export enum InvestmentTableColumn {
	investmentReference = 'investmentReference',
	state = 'state',
	totalInvestment = 'totalInvestment',
	investmentUnits = 'investmentUnits',
	vestingTerm = 'vestingTerm',
	completedDate = 'completedDate',
	actions = 'actions',
}
